<template>
    <div>
        <v-toolbar v-if="$route.query.mode != 'headless'" dark class="primary text-xl-center">
            <v-toolbar-title style="width:100%">
                <img src="/static/images/logo_negative.png" style="  height: 57px;position: absolute; right: 0; top: 2px;">
                Rechner
            </v-toolbar-title>

        </v-toolbar>
        <div v-for="(rechner_list, Gruppe_key) in rechner_Gruppen" :key="Gruppe_key" style="text-align: left;margin-left:40%;margin-top: 25px;">
            <h4 style="text-align: left;">{{ Gruppe_key}}</h4>
            <div v-for="(rechner, rechner_key) in rechner_list" :key="rechner_key" style="margin: 5px 0 0 10px">
                <a :href="'/rechner/'+rechner.url+''+vermittler_fragment">
                    {{rechner.label.replace('-Versicherung','').replace('Versicherung','')}}
                </a>
            </div>

        </div>
    </div>

</template>
<!-- _____________________________________________________________________________________________________________________________________________________________ -->
<!-- ############################################################################################################################################################# -->
<script>

    export default {
        //========================================================================================================
        name: 'Rechner-Page',
        //========================================================================================================
        data: function () {
            return {
                test: 1,
                vermittler_fragment: this.$route.params.vermittlerNr > '' ? '/vermittler/' + this.$route.params.vermittlerNr : '',
                rechner_Gruppen: {
                    'Haftpflicht': {
                        bauherren: {url: 'bauherren-haftpflicht-versicherung', label: 'Bauherren Haftpflicht-Versicherung'},
                        gewaesser: {url: 'gewaesserschaden-haftpflicht-versicherung', label: 'Gewaesserschaden Haftpflicht-Versicherung'},
                        hausgrund: {url: 'haus-und-grundbesitzer-haftpflicht-versicherung', label: 'Haus- und Grundbesitzer Haftpflicht'},
                        privat: {url: 'privat-haftpflicht-versicherung', label: 'Privat-Haftpflicht-Versicherung'},
                        thpferd: {url: 'tierhalter-pferd-haftpflicht-versicherung', label: 'Pferdehalter  Haftpflicht-Versicherung'},
                        thhund: {url: 'tierhalter-hund-haftpflicht-versicherung', label: 'Hundehalter  Haftpflicht-Versicherung'},
                        sporthund: {url: 'tierhalter-hund-haftpflicht-versicherung/vermittler/18756/?tariffilter=sport&tarifgruppe=o', label: 'Sport-Hunde  Haftpflicht-Versicherung'},

                    },
                    'Sach & Unfall': {
                        unfall_Elements: {url: 'unfall_e-versicherung', label: 'Unfall Versicherung Elements'},
                        unfall_Rhion: {url: 'unfall_r-versicherung', label: 'Unfall Versicherung Rhion'},
                        seniorenunfall: {url: 'seniorenunfall-versicherung', label: 'Unfall Versicherung für Senioren'},
                        fahrrad: {url: 'fahrrad-versicherung', label: 'Vollkasko-Versicherung für Fahrräder'},
                        reifen: {url: 'reifen-versicherung', label: 'Reifen-Versicherung'},
                        heizung: {url: 'hausgeraete-versicherung', label: 'Hausgeräte-Versicherung'},
                        glasbruch: {url: 'glasbruch-versicherung', label: 'Glasbruch Versicherung'},
                        hausrat: {url: 'hausrat-versicherung', label: 'Hausrat Versicherung'},
                        wohngebaeude: {url: 'wohngebaeude-versicherung', label: 'Wohngebäude Versicherung'},
                    },
                    'sonstige': {
                        rechtschutz: {url: 'rechtsschutz-versicherung', label: 'Rechtsschutz Versicherung'},
                    },
                }
            }
        }, //=====================================================================================================
        components: {},

        //========================================================================================================
        computed: {}, //==========================================================================================
        methods: {}, //===========================================================================================
        beforeCreate: function () {

        }, //__________________________________________________________________________________________
        created: function () {
        }, //__________________________________________________________________________________________
        mounted: function () {

        }, //__________________________________________________________________________________________
        //========================================================================================================

    }
    //¯
    /*
     ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯
     ¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨
     ………………………………………………………………………
     •••••••••••••••••••••••••••
     »»»»»»»»»»»»»»»»»»»»»»»»»»
     ­­­­­­­­­­­­­­­­­­­­­­­­­­
     ———————————————————————————

     –––––––––––––––––––––
     */
</script>
<!-- ############################################################################################################################################################# -->
<!-- ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯ -->
<style type="less">

</style>
